export default "__VITE_ASSET__DVAz4JfD__"